'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _routingImmutableReducer = require('./routingImmutableReducer');

var _routingImmutableReducer2 = _interopRequireDefault(_routingImmutableReducer);

var _elementsReducer = require('../../common/elements/elementsReducer');

var _elementsReducer2 = _interopRequireDefault(_elementsReducer);

var _usersReducer = require('../user/usersReducer');

var _usersReducer2 = _interopRequireDefault(_usersReducer);

var _appReducer = require('./appReducer');

var _appReducer2 = _interopRequireDefault(_appReducer);

var _undoRedoReducer = require('../utils/undoRedo/undoRedoReducer');

var _undoRedoReducer2 = _interopRequireDefault(_undoRedoReducer);

var _formReducer = require('../components/form/formReducer');

var _formReducer2 = _interopRequireDefault(_formReducer);

var _notificationsReducer = require('../notifications/notificationsReducer');

var _notificationsReducer2 = _interopRequireDefault(_notificationsReducer);

var _lastSavedReducer = require('./lastSavedReducer');

var _lastSavedReducer2 = _interopRequireDefault(_lastSavedReducer);

var _remoteActivityReducer = require('../remoteActivity/remoteActivityReducer');

var _remoteActivityReducer2 = _interopRequireDefault(_remoteActivityReducer);

var _debugReducer = require('../debug/debugReducer');

var _debugReducer2 = _interopRequireDefault(_debugReducer);

var _reducers = require('../utils/services/http/resources/reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _elementCountReducer = require('../user/elementCount/elementCountReducer');

var _elementCountReducer2 = _interopRequireDefault(_elementCountReducer);

var _cache = require('../element/cache');

var _cache2 = _interopRequireDefault(_cache);

var _authConstants = require('../auth/authConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * reducers/index.js
 *  - Returns the root reducer for the client.
 */
var rootReducer = (0, _reduxImmutable.combineReducers)({
    debug: _debugReducer2.default,
    routing: _routingImmutableReducer2.default,
    elements: _elementsReducer2.default,
    users: _usersReducer2.default,
    notifications: _notificationsReducer2.default,
    remoteActivity: _remoteActivityReducer2.default,
    app: _appReducer2.default,
    undoRedo: _undoRedoReducer2.default,
    form: _formReducer2.default,
    lastSaved: _lastSavedReducer2.default,
    resources: _reducers2.default,
    elementCount: _elementCountReducer2.default,
    cache: _cache2.default
});

/**
 * Reset the entire application state when the current user logs out.
 */


// Logout action type
// Lib
var wrappedRootReducer = function wrappedRootReducer(state, action) {
    if (!action.remote && action.type === _authConstants.LOGOUT && action.userId === state.getIn(['app', 'currentUser', '_id'])) {
        return rootReducer(undefined, action);
    }
    return rootReducer(state, action);
};

exports.default = wrappedRootReducer;


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/index.js
// module id = 2041
// module chunks = 0